<h3 mat-dialog-title>This vaccine is not given</h3>

<br>
<div class="float-right">
   <span><button class="btn btn-danger" (click)="notgivenyes('no')">No</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button class="btn btn-primary" (click)="notgivenyes('yes')">Yes</button></span>
</div>
